import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Mechanism } from '../components/Mechanism';
import { MetodoLlave } from '../components/MetodoLlave';
import { WhyOtherApproaches } from '../components/WhyOtherApproaches';
import { DistanceWork } from '../components/DistanceWork';
import { FinalCTA } from '../components/FinalCTA';
export function MetodoPage() {
  return <>
      <PageHeader eyebrow="Acceso al Campo Invisible" title="El Método Llave" subtitle="Una capa más profunda que la mente no alcanza — y las herramientas precisas para llegar a ella." backgroundImage="https://cdn.magicpatterns.com/uploads/e4CskyNRXCsEWCwFkF99ui/fondo_7.png" data-id="element-573" />
      <Mechanism data-id="element-574" />
      <MetodoLlave data-id="element-575" />
      <WhyOtherApproaches data-id="element-576" />
      <DistanceWork data-id="element-577" />
      <FinalCTA data-id="element-578" />
    </>;
}